function formatFirstName(name) {
    if (!name) {
      return "Nome não disponível";
    }
    
    const firstName = name.split(' ')[0]; // Obtém apenas o primeiro nome
    const formattedName = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase(); // Formata o primeiro nome
  
    return formattedName;
  }
  
  export default formatFirstName;
  